/**
 * Parsing methods.
 * @module parse
 */
define(function(require, exports, module) {

    'use strict';

    exports.toTitleCase = function (str) {
        return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/modules/utils/to-title-case.js
// module id = 38
// module chunks = 0